module.exports = __webpack_public_path__ + "img/5.d7cac5b3.jpg";